import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const QualityPolicy = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='qua-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>
      {/* This iqac details part */}

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>Quality policy</h1>
        </div>
      </div>

      {/* This is the body part of the iqac Objectives */}

      <div className='iqac-obj-det'>
        <button onClick={() => setIsOpen(e => !e)}           style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}>Quality policy of the IQAC</button>
        {
          isOpen && (
            <div className='obj-items'>
              <p>
                ✬
                To inculcate moral, ethical and social values among faculty, administrative staff and students.</p>
              <p>
                ✬
                To uphold the vision and mission of this institution by pursuing quality and developing a system.</p>
              <p>
                ✬
                To Pursue global standards of excellence in all our endeavours encompassing teaching, research, consultancy and continuing education.</p>
              <p>
                ✬
                Academic Audit Report</p>
              <p>
                ✬
                To remain focused in our core and support functions and in that direction to hold ourselves accountable to our stakeholders and adhering to globally accepted standards.</p>
              <p>
                ✬

                To enhance the competency of the faculty to higher level and to continually promote the modern methods of teaching-learning-evaluation in various programmes offered.</p>
              <p>
                ✬

                To Maintain suitable documentation to support the Quality Processes and Procedures adopted and it will channelize all efforts and measures of the institution towards promoting its holistic academic excellence.</p>
              <p>
                ✬

                The quality policy will act as a guide to develop the quality assurance framework stating principles, guidelines, and procedures for implementation of institutional quality assurance system.</p>
            </div>
          )

        }

      </div>

      <Footer />
    </div>
  );
}

export default QualityPolicy;
